function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import Badge from '../Badge';

var NavDrawerLink = function NavDrawerLink(_ref) {
  var routerLink = _ref.routerLink,
      href = _ref.href,
      name = _ref.name,
      badge = _ref.badge,
      badgeContext = _ref.badgeContext,
      badgeType = _ref.badgeType,
      hasChildren = _ref.hasChildren,
      isAccordion = _ref.isAccordion,
      _onClick = _ref.onClick,
      _onKeyPress = _ref.onKeyPress,
      onToggle = _ref.onToggle,
      active = _ref.active,
      disabled = _ref.disabled,
      controls = _ref.controls;

  var LinkContent = function LinkContent() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, name, badge && /*#__PURE__*/React.createElement(Badge, {
      type: badgeType,
      value: badge,
      badgeContext: badgeContext
    }));
  };

  var LinkElement = isAccordion ? 'button' : 'a';
  return /*#__PURE__*/React.createElement(React.Fragment, null, routerLink && href ? /*#__PURE__*/React.createElement(NavLink, _extends({
    to: href,
    tabIndex: 0,
    onClick: function onClick(e) {
      if (_onClick) _onClick(e);
      if (!hasChildren) onToggle();
    },
    onKeyPress: function onKeyPress(e) {
      if (_onKeyPress) _onKeyPress(e);
      if (href) onToggle();
    }
  }, isAccordion && {
    'aria-expanded': active,
    'aria-haspopup': true,
    'aria-controls': controls
  }, {
    role: "menuitem"
  }), /*#__PURE__*/React.createElement(LinkContent, null)) : /*#__PURE__*/React.createElement(LinkElement, _extends({}, isAccordion && {
    'aria-expanded': active,
    'aria-haspopup': true,
    'aria-controls': controls
  }, {
    onClick: function onClick(e) {
      if (_onClick) _onClick(e);
      if (!hasChildren) onToggle();
    },
    onKeyPress: function onKeyPress(e) {
      if (_onKeyPress) _onKeyPress(e);
    },
    href: href,
    tabIndex: 0,
    disabled: disabled,
    role: "menuitem"
  }), /*#__PURE__*/React.createElement(LinkContent, null)));
};

NavDrawerLink.propTypes = {
  routerLink: PropTypes.bool,
  controls: PropTypes.string,
  href: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  name: PropTypes.string,
  badge: PropTypes.number,
  badgeContext: PropTypes.string,
  badgeType: PropTypes.oneOf(['positive', 'warning', 'error', 'info']),
  hasChildren: PropTypes.bool,
  isAccordion: PropTypes.bool,
  tabIndex: PropTypes.number,
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  onKeyPress: PropTypes.func,
  onToggle: PropTypes.func
};
NavDrawerLink.defaultProps = {
  routerLink: true
};
NavDrawerLink.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "NavDrawerLink",
  "props": {
    "routerLink": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "controls": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "href": {
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "object"
        }]
      },
      "required": false,
      "description": ""
    },
    "name": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "badge": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "badgeContext": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "badgeType": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "'positive'",
          "computed": false
        }, {
          "value": "'warning'",
          "computed": false
        }, {
          "value": "'error'",
          "computed": false
        }, {
          "value": "'info'",
          "computed": false
        }]
      },
      "required": false,
      "description": ""
    },
    "hasChildren": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "isAccordion": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "tabIndex": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "active": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "disabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onKeyPress": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onToggle": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    }
  }
};
export default NavDrawerLink;